import { createTheme } from '@mui/material';

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    lightBlue: true;
  }
}

export const customTheme = createTheme({
  palette: {
    primary: {
      main: '#0060C9',
      light: '#CAE4FF'
    },
    secondary: {
      main: '#bdbdbd'
    },
    text: {
      primary: '#645C5A'
    }
  },
  typography: {
    fontSize: 16,
    allVariants: {
      color: '#645C5A'
    },
    body2: {
      color: '#333333'
    }
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        size: 'large',
        variant: 'contained'
      },
      variants: [
        {
          props: { variant: 'lightBlue' },
          style: {
            backgroundColor: '#CAE4FF',
            height: '40px',
            color: '#0060C9',
            ':hover': { backgroundColor: '#a3bddc' }
          }
        }
      ]
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        fullWidth: true
      }
    }
  }
});
